module.exports = __webpack_public_path__ + "img/14-doc-acoes-menu.3257fa62.png";